import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../../App";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../../components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { Popover, PopoverContent, PopoverTrigger } from "../../components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "../../components/ui/command";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";
import { Checkbox } from "../../components/ui/checkbox";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../../components/ui/dropdown-menu";
import { DialogoFechaCaja } from "../../components/DialogoFechaCaja";
import { toast } from "sonner";
import { Plus, Pencil, Trash2, ChevronsUpDown, Check, Calculator, Info, Send, Download, FileSpreadsheet, File, FileType, FileJson, FileText } from "lucide-react";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { saveAs } from "file-saver";

const API = process.env.REACT_APP_BACKEND_URL;

const trimestresOpciones = [
  { value: 1, label: "1er Trimestre (Ene-Mar)" },
  { value: 2, label: "2do Trimestre (Abr-Jun)" },
  { value: 3, label: "3er Trimestre (Jul-Sep)" },
  { value: 4, label: "4to Trimestre (Oct-Dic)" }
];

const trimestreLabels = {
  1: "1ER TRIMESTRE PUBLICIDAD",
  2: "2DO TRIMESTRE PUBLICIDAD",
  3: "3ER TRIMESTRE PUBLICIDAD",
  4: "4TO TRIMESTRE PUBLICIDAD"
};

const trimestreShort = { 1: "1er Trim.", 2: "2do Trim.", 3: "3er Trim.", 4: "4to Trim." };

const trimestrePrefixes = { 1: "1ER", 2: "2DO", 3: "3ER", 4: "4TO" };

const findClasificadorForTrimestre = (trimestre, clasificadorItems) => {
  const prefix = trimestrePrefixes[trimestre];
  if (!prefix) return null;
  return clasificadorItems.find(c => {
    const name = (c.nombre_impuesto_tasa || "").toUpperCase();
    return name.includes(prefix) && name.includes("TRIMESTRE");
  }) || null;
};

const generatePendingTrimestres = (lastTrim, lastAnio) => {
  if (!lastTrim || !lastAnio) return [];
  const currentYear = new Date().getFullYear();
  const pending = [];
  let t = parseInt(lastTrim);
  let y = parseInt(lastAnio);
  t++;
  if (t > 4) { t = 1; y++; }
  while (y < currentYear || (y === currentYear && t <= 4)) {
    pending.push({
      trimestre: t,
      anio: y,
      key: `${t}-${y}`,
      label: `${trimestreLabels[t]} ${y}`
    });
    t++;
    if (t > 4) { t = 1; y++; }
  }
  return pending;
};

const getTrimPendientesAviso = (ultimoTrimPago, ultimoAnioPago) => {
  if (!ultimoAnioPago) return [];
  const currentYear = new Date().getFullYear();
  const startTrim = (ultimoTrimPago || 4) + 1;
  const startAnio = startTrim > 4 ? ultimoAnioPago + 1 : ultimoAnioPago;
  const adjustedStartTrim = startTrim > 4 ? 1 : startTrim;
  const pendientes = [];
  let y = startAnio;
  let t = adjustedStartTrim;
  while (y < currentYear || (y === currentYear && t <= 4)) {
    pendientes.push({ trim: t, anio: y, key: `${t}-${y}`, label: `${t === 1 ? "1er" : t === 2 ? "2do" : t === 3 ? "3er" : "4to"} Trim ${y}` });
    t++;
    if (t > 4) { t = 1; y++; }
  }
  return pendientes;
};

const findClasificadorForAviso = (tipoAviso, clasificadorItems) => {
  if (!tipoAviso) return null;
  const normalized = tipoAviso.toUpperCase();
  return clasificadorItems.find(c => {
    const name = (c.nombre_impuesto || c.nombre_impuesto_tasa || "").toUpperCase();
    return name === normalized || name.includes(normalized) || normalized.includes(name);
  }) || null;
};

const PublicidadCalculo = () => {
  const { token } = useAuth();
  const headers = { Authorization: `Bearer ${token}` };

  const [items, setItems] = useState([]);
  const [formData, setFormData] = useState({});
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [fechaCajaDialogOpen, setFechaCajaDialogOpen] = useState(false);
  const [calculoParaEnviar, setCalculoParaEnviar] = useState(null);

  const esMesActual = (fecha) => {
    if (!fecha) return false;
    const hoy = new Date();
    const [y, m] = fecha.split("-");
    return parseInt(y) === hoy.getFullYear() && parseInt(m) === (hoy.getMonth() + 1);
  };
  const [itemToDelete, setItemToDelete] = useState(null);
  const [contribuyentes, setContribuyentes] = useState([]);
  const [rifPopoverOpen, setRifPopoverOpen] = useState(false);
  const [calcPubFilters, setCalcPubFilters] = useState({ nro: "", rif: "", nombre: "", fecha: "", total: "", estatus_pago: "", estatus: "" });

  // Trimestres
  const [conTasasTrimestres, setConTasasTrimestres] = useState(false);
  const [trimestresPendientes, setTrimestresPendientes] = useState([]);
  const [trimestresSeleccionados, setTrimestresSeleccionados] = useState([]);
  const [valorUnidadCuenta, setValorUnidadCuenta] = useState(0);
  const [valorDolar, setValorDolar] = useState(0);
  const [valorEuro, setValorEuro] = useState(0);
  const [clasificadorPub, setClasificadorPub] = useState([]);
  const [clasificadorImpPub, setClasificadorImpPub] = useState([]);

  // Avisos/Vallas
  const [conAvisosVallas, setConAvisosVallas] = useState(false);
  const [avisosRegistrados, setAvisosRegistrados] = useState([]);
  const [aniosSeleccionadosAvisos, setAniosSeleccionadosAvisos] = useState({});

  const [oficinas, setOficinas] = useState([]);
  const [lineaClasPopoverIdx, setLineaClasPopoverIdx] = useState(null);

  useEffect(() => { fetchCalculos(); }, []);

  // ============ FETCH ============
  const fetchCalculos = async () => {
    try { const r = await axios.get(`${API}/api/publicidad/calculo`, { headers }); setItems(r.data); }
    catch { toast.error("Error al cargar calculos"); }
  };
  const fetchContribuyentes = async () => {
    try { const r = await axios.get(`${API}/api/contribuyentes/buscar?clase=con-lae`, { headers }); setContribuyentes(r.data); }
    catch { setContribuyentes([]); }
  };
  const fetchCotizacionActiva = async () => {
    try {
      const r = await axios.get(`${API}/api/publicidad/cotizacion-activa`, { headers });
      setValorUnidadCuenta(r.data.valor_unidad_cuenta || 0);
      setValorDolar(r.data.dolar || 0);
      setValorEuro(r.data.euro || 0);
      return r.data.valor_unidad_cuenta || 0;
    } catch {
      toast.error("No se pudo obtener la cotizacion activa");
      return 0;
    }
  };
  const fetchClasificadorPub = async () => {
    try { const r = await axios.get(`${API}/api/publicidad/clasificador`, { headers }); setClasificadorPub(r.data); return r.data; }
    catch { setClasificadorPub([]); return []; }
  };
  const fetchClasificadorImpPub = async () => {
    try { const r = await axios.get(`${API}/api/publicidad/clasificador-impuestos`, { headers }); setClasificadorImpPub(r.data); return r.data; }
    catch { setClasificadorImpPub([]); return []; }
  };
  const fetchOficinas = async () => {
    try { const r = await axios.get(`${API}/api/definiciones/oficinas`, { headers }); setOficinas(r.data); }
    catch { setOficinas([]); }
  };
  const fetchRegistrosByRif = async (rif) => {
    try {
      const r = await axios.get(`${API}/api/publicidad/registro/by-rif/${encodeURIComponent(rif)}`, { headers });
      const allAvisos = [];
      (r.data || []).forEach((reg) => {
        const avisos = reg.avisos || [{ metros_ancho: reg.metros_ancho, metros_largo: reg.metros_largo, tipo_aviso: reg.tipo_aviso, ultimo_anio_pago: reg.ultimo_anio_pago }];
        avisos.forEach((aviso, aviIdx) => {
          if (aviso.tipo_aviso) {
            allAvisos.push({
              key: `${reg.id}-${aviIdx}`,
              registro_id: reg.id,
              aviso_index: aviIdx,
              tipo_aviso: aviso.tipo_aviso,
              metros_ancho: aviso.metros_ancho || 0,
              metros_largo: aviso.metros_largo || 0,
              ultimo_trimestre_pago: aviso.ultimo_trimestre_pago || null,
              ultimo_anio_pago: aviso.ultimo_anio_pago || null
            });
          }
        });
      });
      setAvisosRegistrados(allAvisos);
      return allAvisos;
    } catch { setAvisosRegistrados([]); return []; }
  };

  // ============ SAVE ============
  const handleSave = async (overrideData) => {
    const payload = overrideData || formData;
    if (!payload.rif) { toast.error("RIF / Contribuyente es obligatorio"); return; }
    try {
      if (editingItem) {
        await axios.put(`${API}/api/publicidad/calculo/${editingItem.id}`, payload, { headers });
        toast.success("Registro actualizado exitosamente");
      } else {
        await axios.post(`${API}/api/publicidad/calculo`, payload, { headers });
        toast.success("Registro creado exitosamente");
      }
      setDialogOpen(false); resetForm(); fetchCalculos();
    } catch (error) { toast.error(error.response?.data?.detail || "Error al guardar"); }
  };

  const resetForm = () => {
    setFormData({});
    setEditingItem(null);
    setConTasasTrimestres(false);
    setTrimestresPendientes([]);
    setTrimestresSeleccionados([]);
    setConAvisosVallas(false);
    setAvisosRegistrados([]);
    setAniosSeleccionadosAvisos({});
  };

  const openNew = async () => {
    resetForm();

    // Auto-montaje de tipos de impuesto anclados a Publicidad
    let anclados = [];
    try {
      const res = await axios.get(`${API}/api/definiciones/tipos-impuesto/anclados/publicidad`, { headers });
      anclados = (res.data || []).map((ti) => ({
        tipo_impuesto_id: ti.id, tipo_impuesto_nombre: ti.nombre, concepto: ti.nombre,
        descripcion: ti.descripcion || ti.nombre, tasa: ti.tasa || 0,
        cantidad: 1, sub_total: 0,
        codigo_presupuestario_id: ti.codigo_presupuestario_id || null, _anclado: true,
      }));
    } catch (err) { console.warn("[anclados/publicidad]", err); toast.warning("No se pudieron cargar los impuestos anclados"); }

    setFormData({ clase_contribuyente: "Contribuyente con LAE", lineas_impuestos: anclados, fecha: new Date().toISOString().split("T")[0] });
    fetchContribuyentes();
    await fetchCotizacionActiva();
    await fetchClasificadorPub();
    fetchClasificadorImpPub();
    fetchOficinas();
    setDialogOpen(true);
  };

  const openEdit = async (item) => {
    setEditingItem(item);
    setFormData({ ...item, clase_contribuyente: "Contribuyente con LAE" });
    fetchContribuyentes();
    await fetchCotizacionActiva();
    if (item.con_tasas_trimestres && item.ultimo_trimestre && item.ultimo_anio) {
      setConTasasTrimestres(true);
      const pending = generatePendingTrimestres(item.ultimo_trimestre, item.ultimo_anio);
      setTrimestresPendientes(pending);
      const sel = (item.lineas_impuestos || [])
        .filter(l => l.auto_trimestre)
        .map(l => l.trimestre_key)
        .filter(Boolean);
      setTrimestresSeleccionados(sel);
    }
    setDialogOpen(true);
  };

  const confirmDelete = async () => {
    try {
      await axios.delete(`${API}/api/publicidad/calculo/${itemToDelete.id}`, { headers });
      toast.success("Registro eliminado");
      setDeleteDialogOpen(false); setItemToDelete(null);
      fetchCalculos();
    } catch { toast.error("Error al eliminar"); }
  };

  const handleEnviarACaja = async (calculo, actualizarFecha = false) => {
    try {
      const url = `${API}/api/publicidad/calculo/${calculo.id}/enviar-caja${actualizarFecha ? '?actualizar_fecha=true' : ''}`;
      const res = await axios.post(url, {}, { headers });
      toast.success(`Calculo enviado a caja. Planilla: ${res.data.nro_planilla}`);
      fetchCalculos();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Error al enviar a caja");
    }
  };

  const handleEnviarACajaClick = (calculo) => {
    if (!esMesActual(calculo.fecha)) {
      setCalculoParaEnviar(calculo);
      setFechaCajaDialogOpen(true);
    } else {
      handleEnviarACaja(calculo);
    }
  };

  // ============ CONTRIBUYENTE SELECTION ============
  const handleContribuyenteSelectCalculo = async (c) => {
    const rif = c.rif.includes("-") ? c.rif : `${c.tipo_rif || "J"}-${c.rif}`;
    const nombre = c.nombre || c.razon_social || c.denominacion_comercial || "";

    // Buscar trimestre/anio de tasa desde publicidad_registro primero
    let trimPub = null;
    let anioPub = null;
    try {
      const regRes = await axios.get(`${API}/api/publicidad/registro`, { headers });
      const regMatch = regRes.data.find(r => r.rif === rif && r.trimestre_publicidad);
      if (regMatch) {
        trimPub = regMatch.trimestre_publicidad;
        anioPub = regMatch.anio_publicidad;
      }
    } catch {}
    // Fallback a contribuyente con LAE si no hay dato en registro
    if (!trimPub) {
      trimPub = c.trimestre_publicidad || null;
      anioPub = c.anio_publicidad || null;
    }

    const newFormData = {
      ...formData,
      rif,
      nombre_razon_social: nombre,
      ultimo_trimestre: trimPub ? parseInt(trimPub) : formData.ultimo_trimestre,
      ultimo_anio: anioPub ? parseInt(anioPub) : formData.ultimo_anio,
    };
    setFormData(newFormData);
    setRifPopoverOpen(false);

    if (trimPub && anioPub) {
      const pending = generatePendingTrimestres(trimPub, anioPub);
      setTrimestresPendientes(pending);
      if (conTasasTrimestres) {
        setTrimestresSeleccionados([]);
        setFormData(prev => ({
          ...prev,
          ...newFormData,
          lineas_impuestos: (prev.lineas_impuestos || []).filter(l => !l.auto_trimestre)
        }));
      }
    } else {
      setTrimestresPendientes([]);
    }

    if (conAvisosVallas) {
      setAniosSeleccionadosAvisos({});
      await fetchRegistrosByRif(rif);
      setFormData(prev => ({
        ...prev,
        lineas_impuestos: (prev.lineas_impuestos || []).filter(l => !l.auto_aviso)
      }));
    }
  };

  // ============ TRIMESTRES CHECKBOX LOGIC ============
  const handleToggleTasasTrimestres = async (checked) => {
    setConTasasTrimestres(checked);
    if (!checked) {
      const manualLines = (formData.lineas_impuestos || []).filter(l => !l.auto_trimestre);
      setFormData({ ...formData, lineas_impuestos: manualLines, con_tasas_trimestres: false });
      setTrimestresSeleccionados([]);
    } else {
      await fetchClasificadorPub();
      fetchClasificadorImpPub();
      setFormData({ ...formData, con_tasas_trimestres: true });
      if (formData.ultimo_trimestre && formData.ultimo_anio) {
        const pending = generatePendingTrimestres(formData.ultimo_trimestre, formData.ultimo_anio);
        setTrimestresPendientes(pending);
      }
    }
  };

  const handleTrimestreCheckbox = (trimestreKey, isChecked) => {
    const idx = trimestresPendientes.findIndex(t => t.key === trimestreKey);
    if (idx === -1) return;

    let newSelected;
    if (isChecked) {
      const keysToSelect = trimestresPendientes.slice(0, idx + 1).map(t => t.key);
      newSelected = [...new Set([...trimestresSeleccionados, ...keysToSelect])];
    } else {
      const keysToDeselect = new Set(trimestresPendientes.slice(idx).map(t => t.key));
      newSelected = trimestresSeleccionados.filter(k => !keysToDeselect.has(k));
    }
    setTrimestresSeleccionados(newSelected);

    const manualLines = (formData.lineas_impuestos || []).filter(l => !l.auto_trimestre);
    const autoLines = newSelected.map(key => {
      const tp = trimestresPendientes.find(t => t.key === key);
      if (!tp) return null;
      const clasif = findClasificadorForTrimestre(tp.trimestre, clasificadorPub);
      const importe = clasif ? (clasif.tasa || 0) : 0;
      const tipoCalculo = clasif ? (clasif.tipo_calculo || "") : "";
      const concepto = clasif
        ? `${clasif.nombre_impuesto_tasa} ${tp.anio}`.toUpperCase()
        : tp.label;
      const existing = (formData.lineas_impuestos || []).find(l => l.trimestre_key === key);
      const finalImporte = existing && existing.importe_manual ? existing.importe : importe;
      const subTotal = tipoCalculo.toLowerCase() === "tasa"
        ? valorUnidadCuenta * finalImporte
        : valorUnidadCuenta * finalImporte / 100;
      return {
        linea_id: `auto-${key}`,
        trimestre_key: key,
        auto_trimestre: true,
        tipo_calculo: tipoCalculo,
        impuesto_tasa: concepto,
        ingreso_bruto: valorUnidadCuenta,
        importe: finalImporte,
        sub_total: subTotal
      };
    }).filter(Boolean);

    setFormData(prev => ({ ...prev, lineas_impuestos: [...autoLines, ...manualLines] }));
  };

  // ============ AVISOS/VALLAS CHECKBOX LOGIC ============
  const handleToggleAvisosVallas = async (checked) => {
    setConAvisosVallas(checked);
    if (!checked) {
      const kept = (formData.lineas_impuestos || []).filter(l => !l.auto_aviso);
      setFormData({ ...formData, lineas_impuestos: kept, con_avisos_vallas: false });
      setAniosSeleccionadosAvisos({});
      setAvisosRegistrados([]);
    } else {
      const clPub = clasificadorPub.length ? clasificadorPub : await fetchClasificadorPub();
      if (!clasificadorImpPub.length) fetchClasificadorImpPub();
      setFormData({ ...formData, con_avisos_vallas: true });
      if (formData.rif) {
        await fetchRegistrosByRif(formData.rif);
      }
    }
  };

  const handleAvisoTrimCheckbox = (avisoKey, trimKey, isChecked) => {
    const aviso = avisosRegistrados.find(a => a.key === avisoKey);
    if (!aviso) return;
    const pendientes = getTrimPendientesAviso(aviso.ultimo_trimestre_pago, aviso.ultimo_anio_pago);
    const idx = pendientes.findIndex(p => p.key === trimKey);
    if (idx === -1) return;

    const prev = aniosSeleccionadosAvisos[avisoKey] || [];
    let newSelected;
    if (isChecked) {
      const toSelect = pendientes.slice(0, idx + 1).map(p => p.key);
      newSelected = [...new Set([...prev, ...toSelect])];
    } else {
      const toDeselect = new Set(pendientes.slice(idx).map(p => p.key));
      newSelected = prev.filter(k => !toDeselect.has(k));
    }

    const newSelections = { ...aniosSeleccionadosAvisos, [avisoKey]: newSelected };
    setAniosSeleccionadosAvisos(newSelections);
    rebuildAvisoLines(newSelections);
  };

  const rebuildAvisoLines = (selections) => {
    const nonAvisoLines = (formData.lineas_impuestos || []).filter(l => !l.auto_aviso);
    const avisoLines = [];

    Object.entries(selections).forEach(([avisoKey, trimKeys]) => {
      const aviso = avisosRegistrados.find(a => a.key === avisoKey);
      if (!aviso) return;
      const clasif = findClasificadorForAviso(aviso.tipo_aviso, clasificadorImpPub);
      const alicuota = clasif ? (clasif.alicuota || 0) : 0;
      const ingresoBruto = (aviso.metros_ancho || 0) * (aviso.metros_largo || 0) * valorUnidadCuenta;

      trimKeys.forEach(trimKey => {
        const [trimStr, anioStr] = trimKey.split("-");
        const trimNum = parseInt(trimStr);
        const anio = parseInt(anioStr);
        const trimLabel = trimNum === 1 ? "1ER" : trimNum === 2 ? "2DO" : trimNum === 3 ? "3ER" : "4TO";
        const concepto = `${aviso.tipo_aviso} ${trimLabel} TRIM ${anio}`.toUpperCase();
        avisoLines.push({
          linea_id: `aviso-${avisoKey}-${trimKey}`,
          aviso_key: avisoKey,
          aviso_trim_key: trimKey,
          aviso_trim: trimNum,
          aviso_anio: anio,
          auto_aviso: true,
          registro_id: aviso.registro_id,
          aviso_index: aviso.aviso_index,
          impuesto_tasa: concepto,
          ingreso_bruto: ingresoBruto,
          importe: alicuota,
          sub_total: ingresoBruto * alicuota
        });
      });
    });

    setFormData(prev => ({ ...prev, lineas_impuestos: [...nonAvisoLines, ...avisoLines] }));
  };

  // ============ LINEAS IMPUESTOS (manual) ============
  const addLinea = () => {
    const lineas = [...(formData.lineas_impuestos || [])];
    lineas.push({ linea_id: Date.now().toString(), impuesto_tasa: "", ingreso_bruto: 0, importe: 0, sub_total: 0, tipo_calculo: "Impuesto" });
    setFormData({ ...formData, lineas_impuestos: lineas });
  };

  const handleSelectClasificadorLinea = (index, clasItem) => {
    const lineas = [...(formData.lineas_impuestos || [])];
    const alicuota = clasItem.alicuota || 0;
    const ib = parseFloat(lineas[index].ingreso_bruto) || 0;
    lineas[index] = {
      ...lineas[index],
      impuesto_tasa: clasItem.nombre_impuesto || "",
      importe: alicuota,
      tipo_calculo: "Impuesto",
      clasificador_imp_id: clasItem.id,
      sub_total: ib * alicuota / 100
    };
    setFormData({ ...formData, lineas_impuestos: lineas });
    setLineaClasPopoverIdx(null);
  };

  const updateLinea = (index, field, value) => {
    const lineas = [...(formData.lineas_impuestos || [])];
    lineas[index] = { ...lineas[index], [field]: value };
    if (field === "ingreso_bruto" || field === "importe") {
      const ib = field === "ingreso_bruto" ? (parseFloat(value) || 0) : (parseFloat(lineas[index].ingreso_bruto) || 0);
      const imp = field === "importe" ? (parseFloat(value) || 0) : (parseFloat(lineas[index].importe) || 0);
      const isTasa = (lineas[index].tipo_calculo || "").toLowerCase() === "tasa";
      lineas[index].sub_total = isTasa ? ib * imp : ib * imp / 100;
    }
    setFormData({ ...formData, lineas_impuestos: lineas });
  };

  const removeLinea = (index) => {
    const lineas = [...(formData.lineas_impuestos || [])];
    const removed = lineas[index];
    lineas.splice(index, 1);
    if (removed?.auto_trimestre && removed?.trimestre_key) {
      const tIdx = trimestresPendientes.findIndex(t => t.key === removed.trimestre_key);
      if (tIdx !== -1) {
        const keysToDeselect = new Set(trimestresPendientes.slice(tIdx).map(t => t.key));
        const newSelected = trimestresSeleccionados.filter(k => !keysToDeselect.has(k));
        setTrimestresSeleccionados(newSelected);
        const finalLines = lineas.filter(l => !l.auto_trimestre || !keysToDeselect.has(l.trimestre_key));
        setFormData({ ...formData, lineas_impuestos: finalLines });
        return;
      }
    }
    if (removed?.auto_aviso && removed?.aviso_key && removed?.aviso_trim_key) {
      const aviso = avisosRegistrados.find(a => a.key === removed.aviso_key);
      if (aviso) {
        const pendientes = getTrimPendientesAviso(aviso.ultimo_trimestre_pago, aviso.ultimo_anio_pago);
        const aIdx = pendientes.findIndex(p => p.key === removed.aviso_trim_key);
        if (aIdx !== -1) {
          const toDeselect = new Set(pendientes.slice(aIdx).map(p => p.key));
          const prev = aniosSeleccionadosAvisos[removed.aviso_key] || [];
          const newSel = prev.filter(k => !toDeselect.has(k));
          const newSelections = { ...aniosSeleccionadosAvisos, [removed.aviso_key]: newSel };
          setAniosSeleccionadosAvisos(newSelections);
          const finalLines = lineas.filter(l => !l.auto_aviso || l.aviso_key !== removed.aviso_key || !toDeselect.has(l.aviso_trim_key));
          setFormData({ ...formData, lineas_impuestos: finalLines });
          return;
        }
      }
    }
    setFormData({ ...formData, lineas_impuestos: lineas });
  };

  const calcTotal = () => {
    const subTotalLineas = (formData.lineas_impuestos || []).reduce((s, l) => s + (l.sub_total || 0), 0);
    return subTotalLineas - (formData.descuento || 0) + (formData.multa || 0);
  };

  // ============ FILTER ============
  const filtered = items.filter(item => {
    const cp = calcPubFilters;
    if (cp.nro && !(item.nro_boletin_publicidad || "").toLowerCase().includes(cp.nro.toLowerCase())) return false;
    if (cp.rif && !(item.rif || "").toLowerCase().includes(cp.rif.toLowerCase())) return false;
    if (cp.nombre && !(item.nombre_razon_social || "").toLowerCase().includes(cp.nombre.toLowerCase())) return false;
    if (cp.fecha && !(item.fecha || "").includes(cp.fecha)) return false;
    if (cp.total && !String(item.total || "").includes(cp.total)) return false;
    if (cp.estatus_pago && cp.estatus_pago !== "todos" && (item.estatus_pago || "Sin pagar") !== cp.estatus_pago) return false;
    if (cp.estatus && cp.estatus !== "todos" && (item.estatus || "Registrado") !== cp.estatus) return false;
    return true;
  });

  // ============ EXPORT ============
  const getExportData = () => filtered.map(item => ({
    "Nro.": item.nro_boletin_publicidad || "",
    "RIF": item.rif || "",
    "Contribuyente": item.nombre_razon_social || "",
    "Fecha": item.fecha || "",
    "Total (Bs.)": (item.total || 0).toFixed(2),
    "Estatus Pago": item.estatus_pago || "Sin pagar",
    "Estatus": item.estatus || "Registrado"
  }));

  const exportToExcel = () => { const d = getExportData(); if (!d.length) { toast.error("No hay datos para exportar"); return; } const ws = XLSX.utils.json_to_sheet(d); const wb = XLSX.utils.book_new(); XLSX.utils.book_append_sheet(wb, ws, "Calculo Publicidad"); XLSX.writeFile(wb, `calculo_publicidad_${new Date().toISOString().split("T")[0]}.xlsx`); toast.success("Exportado a Excel exitosamente"); };
  const exportToPDF = () => { const d = getExportData(); if (!d.length) { toast.error("No hay datos para exportar"); return; } const doc = new jsPDF("landscape"); doc.setFontSize(16); doc.text("Cálculo de Publicidad", 14, 20); doc.setFontSize(10); doc.text(`Fecha: ${new Date().toLocaleDateString("es-VE")}`, 14, 28); autoTable(doc, { head: [Object.keys(d[0])], body: d.map(r => Object.values(r)), startY: 35, styles: { fontSize: 7 }, headStyles: { fillColor: [124, 58, 237] } }); doc.save(`calculo_publicidad_${new Date().toISOString().split("T")[0]}.pdf`); toast.success("Exportado a PDF exitosamente"); };
  const exportToCSV = () => { const d = getExportData(); if (!d.length) { toast.error("No hay datos para exportar"); return; } const h = Object.keys(d[0]).join(","); const rows = d.map(r => Object.values(r).map(v => `"${v}"`).join(",")).join("\n"); saveAs(new Blob(["\ufeff" + h + "\n" + rows], { type: "text/csv;charset=utf-8" }), `calculo_publicidad_${new Date().toISOString().split("T")[0]}.csv`); toast.success("Exportado a CSV exitosamente"); };
  const exportToText = () => { const d = getExportData(); if (!d.length) { toast.error("No hay datos para exportar"); return; } const hs = Object.keys(d[0]); const cw = hs.map(h => Math.max(h.length, ...d.map(r => String(r[h]).length))); let t = "CÁLCULO DE PUBLICIDAD\n"; t += `Fecha: ${new Date().toLocaleDateString("es-VE")}\n`; t += "=".repeat(Math.max(cw.reduce((a, b) => a + b + 3, 0), 50)) + "\n\n"; t += hs.map((h, i) => h.padEnd(cw[i])).join(" | ") + "\n"; t += cw.map(w => "-".repeat(w)).join("-+-") + "\n"; d.forEach(r => { t += hs.map((h, i) => String(r[h]).padEnd(cw[i])).join(" | ") + "\n"; }); saveAs(new Blob([t], { type: "text/plain;charset=utf-8" }), `calculo_publicidad_${new Date().toISOString().split("T")[0]}.txt`); toast.success("Exportado a Texto exitosamente"); };
  const exportToHTML = () => { const d = getExportData(); if (!d.length) { toast.error("No hay datos para exportar"); return; } const hs = Object.keys(d[0]); const html = `<!DOCTYPE html><html lang="es"><head><meta charset="UTF-8"><title>Cálculo de Publicidad</title><style>body{font-family:Arial,sans-serif;padding:20px}h1{color:#7c3aed}table{border-collapse:collapse;width:100%;margin-top:20px}th,td{border:1px solid #ddd;padding:10px;text-align:left;font-size:12px}th{background-color:#7c3aed;color:white}tr:nth-child(even){background-color:#f9fafb}tr:hover{background-color:#f3f4f6}.fecha{color:#6b7280;margin-bottom:20px}</style></head><body><h1>Cálculo de Publicidad</h1><p class="fecha">Fecha: ${new Date().toLocaleDateString("es-VE")}</p><table><thead><tr>${hs.map(h => `<th>${h}</th>`).join("")}</tr></thead><tbody>${d.map(r => `<tr>${Object.values(r).map(v => `<td>${v}</td>`).join("")}</tr>`).join("")}</tbody></table></body></html>`; saveAs(new Blob([html], { type: "text/html;charset=utf-8" }), `calculo_publicidad_${new Date().toISOString().split("T")[0]}.html`); toast.success("Exportado a HTML exitosamente"); };
  const exportToJSON = () => { const d = getExportData(); if (!d.length) { toast.error("No hay datos para exportar"); return; } saveAs(new Blob([JSON.stringify(d, null, 2)], { type: "application/json" }), `calculo_publicidad_${new Date().toISOString().split("T")[0]}.json`); toast.success("Exportado a JSON exitosamente"); };

  // ============ RENDER ============
  return (
    <div className="space-y-6" data-testid="publicidad-calculo-page">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">Cálculo de Publicidad</h1>
          <p className="text-slate-500">Gestión de cálculos de publicidad comercial</p>
        </div>
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-1.5 px-3 py-1.5 bg-blue-50 border border-blue-200 rounded-lg text-sm" data-testid="registro-counter">
            <span className="font-bold text-blue-800">{filtered.length}</span>
            <span className="text-blue-600">de</span>
            <span className="font-bold text-blue-800">{items.length}</span>
            <span className="text-blue-600">registros</span>
          </div>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="outline" className="gap-2" data-testid="btn-exportar-calc-pub"><Download className="w-4 h-4" /> Exportar</Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem onClick={exportToExcel} className="gap-2 cursor-pointer"><FileSpreadsheet className="w-4 h-4" /> Excel</DropdownMenuItem>
              <DropdownMenuItem onClick={exportToPDF} className="gap-2 cursor-pointer"><FileText className="w-4 h-4" /> PDF</DropdownMenuItem>
              <DropdownMenuItem onClick={exportToCSV} className="gap-2 cursor-pointer"><FileText className="w-4 h-4" /> CSV</DropdownMenuItem>
              <DropdownMenuItem onClick={exportToText} className="gap-2 cursor-pointer"><File className="w-4 h-4" /> Texto</DropdownMenuItem>
              <DropdownMenuItem onClick={exportToHTML} className="gap-2 cursor-pointer"><FileType className="w-4 h-4" /> HTML</DropdownMenuItem>
              <DropdownMenuItem onClick={exportToJSON} className="gap-2 cursor-pointer"><FileJson className="w-4 h-4" /> JSON</DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
          <Button onClick={openNew} className="bg-purple-600 hover:bg-purple-700" data-testid="btn-nuevo-calculo">
            <Plus className="w-4 h-4 mr-2" /> Nuevo
          </Button>
        </div>
      </div>
      <div className="bg-white rounded-xl shadow-sm border overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow className="bg-slate-50">
              <TableHead>Nro.</TableHead><TableHead>RIF</TableHead><TableHead>Contribuyente</TableHead>
              <TableHead>Fecha</TableHead><TableHead className="text-right">Total (Bs.)</TableHead>
              <TableHead>Estatus Pago</TableHead><TableHead>Estatus</TableHead><TableHead className="text-right">Acciones</TableHead>
            </TableRow>
            <TableRow className="bg-slate-50/50 border-b">
              <TableHead className="px-2 py-1.5"><Input className="h-7 text-xs" placeholder="Filtrar..." value={calcPubFilters.nro} onChange={(e) => setCalcPubFilters({...calcPubFilters, nro: e.target.value})} data-testid="filter-calcpub-nro" /></TableHead>
              <TableHead className="px-2 py-1.5"><Input className="h-7 text-xs" placeholder="Filtrar..." value={calcPubFilters.rif} onChange={(e) => setCalcPubFilters({...calcPubFilters, rif: e.target.value})} data-testid="filter-calcpub-rif" /></TableHead>
              <TableHead className="px-2 py-1.5"><Input className="h-7 text-xs" placeholder="Filtrar..." value={calcPubFilters.nombre} onChange={(e) => setCalcPubFilters({...calcPubFilters, nombre: e.target.value})} data-testid="filter-calcpub-nombre" /></TableHead>
              <TableHead className="px-2 py-1.5"><Input type="date" className="h-7 text-xs" value={calcPubFilters.fecha} onChange={(e) => setCalcPubFilters({...calcPubFilters, fecha: e.target.value})} data-testid="filter-calcpub-fecha" /></TableHead>
              <TableHead className="px-2 py-1.5"><Input className="h-7 text-xs text-right" placeholder="Filtrar..." value={calcPubFilters.total} onChange={(e) => setCalcPubFilters({...calcPubFilters, total: e.target.value})} data-testid="filter-calcpub-total" /></TableHead>
              <TableHead className="px-2 py-1.5">
                <select className="h-7 w-full text-xs border rounded-md px-1 bg-white text-slate-700" value={calcPubFilters.estatus_pago} onChange={(e) => setCalcPubFilters({...calcPubFilters, estatus_pago: e.target.value})} data-testid="filter-calcpub-estatus-pago">
                  <option value="todos">Todos</option><option value="Sin pagar">Sin pagar</option><option value="Pagado">Pagado</option>
                </select>
              </TableHead>
              <TableHead className="px-2 py-1.5">
                <select className="h-7 w-full text-xs border rounded-md px-1 bg-white text-slate-700" value={calcPubFilters.estatus} onChange={(e) => setCalcPubFilters({...calcPubFilters, estatus: e.target.value})} data-testid="filter-calcpub-estatus">
                  <option value="todos">Todos</option><option value="Registrado">Registrado</option><option value="Enviado a Caja">Enviado a Caja</option><option value="Anulado">Anulado</option>
                </select>
              </TableHead>
              <TableHead className="px-2 py-1.5"></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {filtered.length === 0 ? (
              <TableRow><TableCell colSpan={8} className="text-center py-8 text-slate-400">No hay calculos</TableCell></TableRow>
            ) : filtered.map((item) => (
              <TableRow key={item.id}>
                <TableCell className="font-mono text-sm">{item.nro_boletin_publicidad}</TableCell>
                <TableCell className="font-mono text-sm">{item.rif}</TableCell>
                <TableCell className="text-sm">{item.nombre_razon_social || "-"}</TableCell>
                <TableCell className="text-sm">{item.fecha || "-"}</TableCell>
                <TableCell className="text-sm text-right font-medium">{(item.total || 0).toLocaleString("es-VE", { minimumFractionDigits: 2 })}</TableCell>
                <TableCell>
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${item.estatus_pago === "Pagado" ? "bg-green-100 text-green-700" : "bg-amber-100 text-amber-700"}`}>
                    {item.estatus_pago || "Sin pagar"}
                  </span>
                </TableCell>
                <TableCell>
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${item.estatus === "Enviado a Caja" ? "bg-blue-100 text-blue-700" : item.estatus === "Anulado" ? "bg-red-100 text-red-700" : "bg-slate-100 text-slate-700"}`}>
                    {item.estatus || "Registrado"}
                  </span>
                </TableCell>
                <TableCell className="text-right">
                  <div className="flex justify-end gap-1">
                    {item.estatus !== "Enviado a Caja" && item.estatus !== "Anulado" && (
                      <Button variant="ghost" size="icon" title="Enviar a Caja" onClick={() => handleEnviarACaja(item)} data-testid={`btn-enviar-caja-${item.id}`}><Send className="w-4 h-4 text-green-600" /></Button>
                    )}
                    <Button variant="ghost" size="icon" onClick={() => openEdit(item)} data-testid={`btn-edit-${item.id}`}><Pencil className="w-4 h-4 text-blue-600" /></Button>
                    <Button variant="ghost" size="icon" onClick={() => { setItemToDelete(item); setDeleteDialogOpen(true); }} data-testid={`btn-delete-${item.id}`}><Trash2 className="w-4 h-4 text-red-500" /></Button>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      {/* Calculo Form Dialog */}
      <Dialog open={dialogOpen} onOpenChange={(open) => { if (!open) resetForm(); setDialogOpen(open); }}>
        <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Calculator className="w-5 h-5 text-purple-600" />
              {editingItem ? "Editar Cálculo" : "Nuevo Cálculo de Publicidad"}
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4 py-2">
            {/* Header */}
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label>Clase de Contribuyente</Label>
                <Input value="Contribuyente con LAE" readOnly className="bg-slate-50" data-testid="form-clase-calculo" />
              </div>
              <div className="space-y-2">
                <Label>Fecha</Label>
                <Input type="date" value={formData.fecha || ""} onChange={(e) => setFormData({ ...formData, fecha: e.target.value })} data-testid="form-fecha-calculo" />
              </div>
            </div>

            {/* RIF Selector */}
            <div className="space-y-2">
              <Label>RIF / Contribuyente *</Label>
              <Popover open={rifPopoverOpen} onOpenChange={setRifPopoverOpen}>
                <PopoverTrigger asChild>
                  <Button variant="outline" role="combobox" className="w-full justify-between h-auto min-h-[40px] text-left font-normal" data-testid="form-rif-contribuyente">
                    {formData.rif ? `${formData.rif} - ${formData.nombre_razon_social || ""}` : "Seleccione contribuyente"}
                    <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                  </Button>
                </PopoverTrigger>
                <PopoverContent className="w-[450px] p-0" align="start">
                  <Command>
                    <CommandInput placeholder="Buscar por RIF o nombre..." />
                    <CommandList>
                      <CommandEmpty>No se encontraron contribuyentes</CommandEmpty>
                      <CommandGroup>
                        {contribuyentes.map((c) => (
                          <CommandItem
                            key={c.id || c.rif}
                            value={`${c.display_name || c.rif}`}
                            onSelect={() => handleContribuyenteSelectCalculo(c)}
                          >
                            <Check className={`mr-2 h-4 w-4 ${formData.rif === c.rif ? "opacity-100" : "opacity-0"}`} />
                            <span className="text-sm">{c.display_name || c.rif}</span>
                          </CommandItem>
                        ))}
                      </CommandGroup>
                    </CommandList>
                  </Command>
                </PopoverContent>
              </Popover>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label>Nombre / Razón Social</Label>
                <Input value={formData.nombre_razon_social || ""} readOnly className="bg-slate-50" data-testid="form-nombre-calculo" />
              </div>
              <div className="space-y-2">
                <Label>Oficina</Label>
                <Select value={formData.oficina || ""} onValueChange={(v) => setFormData({...formData, oficina: v})}>
                  <SelectTrigger data-testid="form-oficina-calculo"><SelectValue placeholder="Seleccione oficina" /></SelectTrigger>
                  <SelectContent>
                    {oficinas.map((o) => <SelectItem key={o.id || o.nombre} value={o.nombre}>{o.nombre}</SelectItem>)}
                  </SelectContent>
                </Select>
              </div>
            </div>

            {/* Último Trimestre Publicidad Pago */}
            <div className="bg-slate-50 rounded-lg p-4 border">
              <h3 className="text-sm font-semibold text-slate-700 mb-3">Último Trimestre Publicidad Pago</h3>
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label>Trimestre</Label>
                  <Select value={String(formData.ultimo_trimestre || "")} onValueChange={(v) => {
                    const newForm = { ...formData, ultimo_trimestre: parseInt(v) };
                    setFormData(newForm);
                    if (newForm.ultimo_anio) {
                      setTrimestresPendientes(generatePendingTrimestres(parseInt(v), newForm.ultimo_anio));
                      if (conTasasTrimestres) { setTrimestresSeleccionados([]); setFormData(f => ({ ...f, ...newForm, lineas_impuestos: (f.lineas_impuestos || []).filter(l => !l.auto_trimestre) })); }
                    }
                  }}>
                    <SelectTrigger data-testid="form-trimestre"><SelectValue placeholder="Seleccione trimestre" /></SelectTrigger>
                    <SelectContent>{trimestresOpciones.map((t) => <SelectItem key={t.value} value={String(t.value)}>{t.label}</SelectItem>)}</SelectContent>
                  </Select>
                </div>
                <div className="space-y-2">
                  <Label>Año del Trimestre</Label>
                  <Input type="number" value={formData.ultimo_anio ?? ""} onChange={(e) => {
                    const anio = parseInt(e.target.value) || null;
                    const newForm = { ...formData, ultimo_anio: anio };
                    setFormData(newForm);
                    if (anio && newForm.ultimo_trimestre) {
                      setTrimestresPendientes(generatePendingTrimestres(newForm.ultimo_trimestre, anio));
                      if (conTasasTrimestres) { setTrimestresSeleccionados([]); setFormData(f => ({ ...f, ...newForm, lineas_impuestos: (f.lineas_impuestos || []).filter(l => !l.auto_trimestre) })); }
                    }
                  }} placeholder="Ej: 2025" data-testid="form-anio-trimestre" />
                </div>
              </div>
            </div>

            {/* Checkbox: Con tasas por trimestres */}
            <div className="flex items-center space-x-3 bg-purple-50 border border-purple-200 rounded-lg p-4" data-testid="checkbox-tasas-trimestres-container">
              <Checkbox
                id="con-tasas-trimestres"
                checked={conTasasTrimestres}
                onCheckedChange={handleToggleTasasTrimestres}
                data-testid="checkbox-tasas-trimestres"
              />
              <label htmlFor="con-tasas-trimestres" className="text-sm font-medium text-purple-800 cursor-pointer select-none">
                Con tasas por Trimestres de Publicidad?
              </label>
            </div>

            {/* Trimestres Pendientes */}
            {conTasasTrimestres && (
              <div className="bg-white rounded-lg border" data-testid="trimestres-pendientes-section">
                <div className="px-4 py-3 border-b bg-slate-50">
                  <h3 className="text-sm font-semibold text-slate-700">Trimestres Pendientes por Pago</h3>
                  {trimestresPendientes.length > 0 && (
                    <p className="text-xs text-slate-500 mt-1">
                      <Info className="inline w-3 h-3 mr-1" />
                      Al seleccionar un trimestre, se incluyen automaticamente los trimestres anteriores pendientes (prelacion)
                    </p>
                  )}
                </div>
                <div className="p-4">
                  {!formData.ultimo_trimestre || !formData.ultimo_anio ? (
                    <p className="text-sm text-amber-600 text-center py-3">
                      Seleccione un contribuyente o ingrese el ultimo trimestre y ano de pago
                    </p>
                  ) : trimestresPendientes.length === 0 ? (
                    <p className="text-sm text-green-600 text-center py-3">
                      No hay trimestres pendientes. El contribuyente esta al dia.
                    </p>
                  ) : (
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
                      {trimestresPendientes.map((tp) => {
                        const isSelected = trimestresSeleccionados.includes(tp.key);
                        return (
                          <div
                            key={tp.key}
                            className={`flex items-center space-x-2 p-2 rounded-md border cursor-pointer transition-colors ${
                              isSelected ? "bg-purple-50 border-purple-300" : "bg-white border-slate-200 hover:bg-slate-50"
                            }`}
                            onClick={() => handleTrimestreCheckbox(tp.key, !isSelected)}
                            data-testid={`trimestre-checkbox-${tp.key}`}
                          >
                            <Checkbox
                              checked={isSelected}
                              onCheckedChange={(checked) => handleTrimestreCheckbox(tp.key, checked)}
                            />
                            <span className={`text-xs font-medium ${isSelected ? "text-purple-800" : "text-slate-600"}`}>
                              {trimestreShort[tp.trimestre]} {tp.anio}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Checkbox: Con Avisos o Vallas */}
            <div className="flex items-center space-x-3 bg-amber-50 border border-amber-200 rounded-lg p-4" data-testid="checkbox-avisos-vallas-container">
              <Checkbox
                id="con-avisos-vallas"
                checked={conAvisosVallas}
                onCheckedChange={handleToggleAvisosVallas}
                data-testid="checkbox-avisos-vallas"
              />
              <label htmlFor="con-avisos-vallas" className="text-sm font-medium text-amber-800 cursor-pointer select-none">
                Con Avisos o Vallas Publicitarias?
              </label>
            </div>

            {/* Avisos Pendientes */}
            {conAvisosVallas && (
              <div className="bg-white rounded-lg border" data-testid="avisos-pendientes-section">
                <div className="px-4 py-3 border-b bg-slate-50">
                  <h3 className="text-sm font-semibold text-slate-700">Avisos / Vallas - Trimestres Pendientes por Pago</h3>
                  {avisosRegistrados.length > 0 && (
                    <p className="text-xs text-slate-500 mt-1">
                      <Info className="inline w-3 h-3 mr-1" />
                      Al seleccionar un trimestre, se incluyen automaticamente los trimestres anteriores pendientes (prelacion)
                    </p>
                  )}
                </div>
                <div className="p-4 space-y-4">
                  {!formData.rif ? (
                    <p className="text-sm text-amber-600 text-center py-3">Seleccione un contribuyente primero</p>
                  ) : avisosRegistrados.length === 0 ? (
                    <p className="text-sm text-slate-500 text-center py-3">No hay avisos registrados para este contribuyente</p>
                  ) : avisosRegistrados.map((aviso) => {
                    const pendientes = getTrimPendientesAviso(aviso.ultimo_trimestre_pago, aviso.ultimo_anio_pago);
                    const selected = aniosSeleccionadosAvisos[aviso.key] || [];
                    return (
                      <div key={aviso.key} className="border rounded-lg p-3 space-y-2">
                        <div className="flex items-center justify-between">
                          <span className="text-sm font-medium text-slate-800">{aviso.tipo_aviso}</span>
                          <span className="text-xs text-slate-500">
                            {aviso.metros_ancho} x {aviso.metros_largo} m | Ult. pago: {aviso.ultimo_trimestre_pago ? `${aviso.ultimo_trimestre_pago}T ${aviso.ultimo_anio_pago}` : aviso.ultimo_anio_pago || "Sin info"}
                          </span>
                        </div>
                        {!aviso.ultimo_anio_pago ? (
                          <p className="text-xs text-amber-600">Sin informacion de ultimo trimestre/ano de pago</p>
                        ) : pendientes.length === 0 ? (
                          <p className="text-xs text-green-600">Al dia - sin trimestres pendientes</p>
                        ) : (
                          <div className="flex flex-wrap gap-2">
                            {pendientes.map((tp) => {
                              const isSel = selected.includes(tp.key);
                              return (
                                <div
                                  key={tp.key}
                                  className={`flex items-center space-x-2 px-3 py-1.5 rounded-md border cursor-pointer transition-colors ${
                                    isSel ? "bg-amber-50 border-amber-300" : "bg-white border-slate-200 hover:bg-slate-50"
                                  }`}
                                  onClick={() => handleAvisoTrimCheckbox(aviso.key, tp.key, !isSel)}
                                  data-testid={`aviso-trim-${aviso.key}-${tp.key}`}
                                >
                                  <Checkbox checked={isSel} onCheckedChange={(c) => handleAvisoTrimCheckbox(aviso.key, tp.key, c)} />
                                  <span className={`text-xs font-medium ${isSel ? "text-amber-800" : "text-slate-600"}`}>{tp.label}</span>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {/* Lineas de Impuestos/Tasas */}
            <div className="bg-white rounded-lg border">
              <div className="flex items-center justify-between px-4 py-3 border-b bg-slate-50">
                <h3 className="text-sm font-semibold text-slate-700">Lineas de Impuestos/Tasas</h3>
                <Button size="sm" variant="outline" onClick={addLinea} data-testid="btn-add-linea">
                  <Plus className="w-3 h-3 mr-1" /> Agregar Linea
                </Button>
              </div>
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b bg-slate-50/50">
                      <th className="px-3 py-2 text-left font-medium text-slate-600">IMPUESTOS/TASAS</th>
                      <th className="px-3 py-2 text-right font-medium text-slate-600">INGRESO BRUTO</th>
                      <th className="px-3 py-2 text-right font-medium text-slate-600">IMPORTE</th>
                      <th className="px-3 py-2 text-right font-medium text-slate-600">SUB TOTAL</th>
                      <th className="px-3 py-2 w-10"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {(formData.lineas_impuestos || []).length === 0 ? (
                      <tr><td colSpan={5} className="text-center py-6 text-slate-400">No hay lineas de impuestos</td></tr>
                    ) : (formData.lineas_impuestos || []).map((linea, idx) => (
                      <tr key={linea.linea_id || idx} className="border-t" data-testid="linea-impuesto-row" data-tipo-nombre={linea.impuesto_tasa || linea.tipo_impuesto_nombre || linea.concepto || ""} data-anclado={linea._anclado ? "true" : "false"}>
                        <td className="px-3 py-2">
                          {(linea.auto_trimestre || linea.auto_aviso) ? (
                            <span className="text-sm font-medium text-purple-700" data-testid={`linea-concepto-${idx}`}>{linea.impuesto_tasa}</span>
                          ) : (
                            <Popover open={lineaClasPopoverIdx === idx} onOpenChange={(open) => setLineaClasPopoverIdx(open ? idx : null)}>
                              <PopoverTrigger asChild>
                                <Button variant="outline" className="w-full justify-between h-8 text-sm font-normal text-left" data-testid={`linea-concepto-${idx}`}>
                                  {linea.impuesto_tasa || <span className="text-slate-400">Seleccionar impuesto...</span>}
                                  <ChevronsUpDown className="ml-1 h-3 w-3 shrink-0 opacity-50" />
                                </Button>
                              </PopoverTrigger>
                              <PopoverContent className="w-[350px] p-0" align="start">
                                <Command>
                                  <CommandInput placeholder="Buscar impuesto..." />
                                  <CommandList>
                                    <CommandEmpty>No se encontraron impuestos</CommandEmpty>
                                    <CommandGroup heading="Clasificador Impuestos">
                                      {clasificadorImpPub.map((ci) => (
                                        <CommandItem key={ci.id} value={`${ci.nombre_impuesto} ${ci.codigo_presupuestario || ""}`} onSelect={() => handleSelectClasificadorLinea(idx, ci)}>
                                          <Check className={`mr-2 h-4 w-4 ${linea.clasificador_imp_id === ci.id ? "opacity-100" : "opacity-0"}`} />
                                          <div className="flex flex-col">
                                            <span className="text-sm">{ci.nombre_impuesto}</span>
                                            <span className="text-xs text-slate-500">Alicuota: {(ci.alicuota || 0).toFixed(2)}%</span>
                                          </div>
                                        </CommandItem>
                                      ))}
                                    </CommandGroup>
                                  </CommandList>
                                </Command>
                              </PopoverContent>
                            </Popover>
                          )}
                        </td>
                        <td className="px-3 py-2">
                          {(linea.auto_trimestre || linea.auto_aviso) ? (
                            <span className="text-sm text-right block font-mono" data-testid={`linea-ingreso-${idx}`}>{(linea.ingreso_bruto || 0).toLocaleString("es-VE", { minimumFractionDigits: 2 })}</span>
                          ) : (
                            <Input type="number" step="0.01" className="h-8 text-sm text-right" value={linea.ingreso_bruto || ""} onChange={(e) => updateLinea(idx, "ingreso_bruto", e.target.value)} placeholder="0.00" data-testid={`linea-ingreso-${idx}`} />
                          )}
                        </td>
                        <td className="px-3 py-2">
                          <Input type="number" step="0.01" className="h-8 text-sm text-right" value={linea.importe || ""} onChange={(e) => updateLinea(idx, "importe", e.target.value)} placeholder="0.00" data-testid={`linea-importe-${idx}`} />
                        </td>
                        <td className="px-3 py-2 text-right font-medium text-slate-700">
                          {(linea.sub_total || 0).toLocaleString("es-VE", { minimumFractionDigits: 2 })}
                        </td>
                        <td className="px-3 py-2">
                          <Button variant="ghost" size="icon" className="h-7 w-7" onClick={() => removeLinea(idx)} data-testid={`btn-remove-linea-${idx}`}><Trash2 className="w-3 h-3 text-red-500" /></Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {conTasasTrimestres && valorUnidadCuenta > 0 && (
                <div className="px-4 py-2 bg-blue-50 border-t text-xs text-blue-700">
                  Valor Unidad de Cuenta (Activa): Bs. {valorUnidadCuenta.toLocaleString("es-VE", { minimumFractionDigits: 2 })}
                </div>
              )}
            </div>

            {/* Totales */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
              <div className="space-y-1">
                <Label className="text-xs">Descuento (Bs.)</Label>
                <Input type="number" step="0.01" className="h-8 text-sm text-right" value={formData.descuento ?? ""} onChange={(e) => setFormData({ ...formData, descuento: parseFloat(e.target.value) || 0 })} placeholder="0.00" data-testid="form-descuento" />
              </div>
              <div className="space-y-1">
                <Label className="text-xs">Reintegro (Bs.)</Label>
                <div className="h-8 flex items-center justify-end px-3 bg-slate-50 border border-slate-200 rounded-md text-sm font-medium text-slate-700" data-testid="form-reintegro">0,00</div>
              </div>
              <div className="space-y-1">
                <Label className="text-xs">Retención (Bs.)</Label>
                <div className="h-8 flex items-center justify-end px-3 bg-slate-50 border border-slate-200 rounded-md text-sm font-medium text-slate-700" data-testid="form-retencion">0,00</div>
              </div>
              <div className="space-y-1">
                <Label className="text-xs">Multa (Bs.)</Label>
                <Input type="number" step="0.01" className="h-8 text-sm text-right" value={formData.multa ?? ""} onChange={(e) => setFormData({ ...formData, multa: parseFloat(e.target.value) || 0 })} placeholder="0.00" data-testid="form-multa" />
              </div>
            </div>
            <div className="grid grid-cols-3 gap-3">
              <div className="space-y-1">
                <Label className="text-xs">Divisas ($)</Label>
                <div className="h-8 flex items-center justify-end px-3 bg-slate-50 border border-slate-200 rounded-md text-sm font-medium text-slate-700" data-testid="form-divisas-usd">
                  {valorDolar > 0 ? (calcTotal() / valorDolar).toLocaleString("es-VE", { minimumFractionDigits: 2 }) : "0.00"}
                </div>
              </div>
              <div className="space-y-1">
                <Label className="text-xs">Divisas (E)</Label>
                <div className="h-8 flex items-center justify-end px-3 bg-slate-50 border border-slate-200 rounded-md text-sm font-medium text-slate-700" data-testid="form-divisas-eur">
                  {valorEuro > 0 ? (calcTotal() / valorEuro).toLocaleString("es-VE", { minimumFractionDigits: 2 }) : "0.00"}
                </div>
              </div>
              <div className="space-y-1">
                <Label className="text-xs font-bold">Total (Bs.)</Label>
                <div className="h-8 flex items-center justify-end px-3 bg-purple-50 border border-purple-200 rounded-md font-bold text-purple-800 text-sm" data-testid="form-total">
                  {calcTotal().toLocaleString("es-VE", { minimumFractionDigits: 2 })}
                </div>
              </div>
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => { resetForm(); setDialogOpen(false); }}>Cancelar</Button>
            <Button onClick={() => handleSave({ ...formData, total: calcTotal(), divisas_usd: valorDolar > 0 ? parseFloat((calcTotal() / valorDolar).toFixed(2)) : 0, divisas_eur: valorEuro > 0 ? parseFloat((calcTotal() / valorEuro).toFixed(2)) : 0, con_tasas_trimestres: conTasasTrimestres, con_avisos_vallas: conAvisosVallas })} className="bg-purple-600 hover:bg-purple-700" data-testid="btn-guardar-calculo">
              {editingItem ? "Actualizar" : "Guardar"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Delete Confirmation */}
      <Dialog open={deleteDialogOpen} onOpenChange={setDeleteDialogOpen}>
        <DialogContent className="max-w-sm">
          <DialogHeader><DialogTitle>Confirmar Eliminacion</DialogTitle></DialogHeader>
          <p className="text-sm text-slate-600">Esta seguro de eliminar este calculo?</p>
          <DialogFooter>
            <Button variant="outline" onClick={() => setDeleteDialogOpen(false)}>Cancelar</Button>
            <Button variant="destructive" onClick={confirmDelete} data-testid="btn-confirm-delete">Eliminar</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <DialogoFechaCaja
        open={fechaCajaDialogOpen}
        onOpenChange={setFechaCajaDialogOpen}
        fechaCalculo={calculoParaEnviar?.fecha}
        onConfirm={() => {
          setFechaCajaDialogOpen(false);
          handleEnviarACaja(calculoParaEnviar, true);
          setCalculoParaEnviar(null);
        }}
        onCancel={() => {
          setFechaCajaDialogOpen(false);
          setCalculoParaEnviar(null);
        }}
      />
    </div>
  );
};

export default PublicidadCalculo;
